import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"

//////////////////////////////////////////////////////////////
//                           Clients                        //
//////////////////////////////////////////////////////////////

export const FETCH_CLIENTSDB_BEGIN = "FETCH_CLIENTSDB_BEGIN"
export const FETCH_CLIENTSDB_ERROR = "FETCH_CLIENTSDB_ERROR"
export const FETCH_CLIENTSDB_SUCCESS = "FETCH_CLIENTSDB_SUCCESS"
export const FETCH_CLIENTSDB_RESET = "FETCH_CLIENTSDB_RESET"

export const fetchClientsDBBegin = () => ({
	type: FETCH_CLIENTSDB_BEGIN,
})

export const fetchClientsDBError = (error) => ({
	type: FETCH_CLIENTSDB_ERROR,
	payload: { error },
})

export const fetchClientsDBSuccess = (data) => ({
	type: FETCH_CLIENTSDB_SUCCESS,
	payload: { data },
})

export const fetchClientsDBReset = () => ({
	type: FETCH_CLIENTSDB_RESET,
})

export function fetchClientsDB(obj) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchClientsDBBegin())
		let url = `${URL}api/clientsdb?`
		for (let [key, val] of Object.entries(obj)) url += `${key}=${val}&`
		return fetch(url.slice(0, -1), {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchClientsDBSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchClientsDBError))
	}
}

export const POST_CLIENTSDB_BEGIN = "POST_CLIENTSDB_BEGIN"
export const POST_CLIENTSDB_ERROR = "POST_CLIENTSDB_ERROR"
export const POST_CLIENTSDB_SUCCESS = "POST_CLIENTSDB_SUCCESS"
export const POST_CLIENTSDB_RESET = "POST_CLIENTSDB_RESET"

export const postClientsDBBegin = () => ({
	type: POST_CLIENTSDB_BEGIN,
})

export const postClientsDBError = (error) => ({
	type: POST_CLIENTSDB_ERROR,
	payload: { error },
})

export const postClientsDBSuccess = (data) => ({
	type: POST_CLIENTSDB_SUCCESS,
	payload: { data },
})

export const postClientsDBReset = () => ({
	type: POST_CLIENTSDB_RESET,
})

export function postClientsDB(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postClientsDBBegin())
		let url = `${URL}api/clientsdb`
		return fetch(url, {
			method: "post",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			// //     // 'Accept': 'application/json, text/plain',
			//     // 'Content-type': 'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW'
			// },
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postClientsDBSuccess(json))
			})
			.catch(catchApiError(dispatch, postClientsDBError))
	}
}

//////////////////////////////////////////////////////////////
//                   Clients Travaux                       //
//////////////////////////////////////////////////////////////

export const FETCH_CLIENTS_TRAVAUX_BEGIN = "FETCH_CLIENTS_TRAVAUX_BEGIN"
export const FETCH_CLIENTS_TRAVAUX_ERROR = "FETCH_CLIENTS_TRAVAUX_ERROR"
export const FETCH_CLIENTS_TRAVAUX_SUCCESS = "FETCH_CLIENTS_TRAVAUX_SUCCESS"
export const FETCH_CLIENTS_TRAVAUX_RESET = "FETCH_CLIENTS_TRAVAUX_RESET"

export const fetchClientsTravauxBegin = () => ({
	type: FETCH_CLIENTS_TRAVAUX_BEGIN,
})

export const fetchClientsTravauxError = (error) => ({
	type: FETCH_CLIENTS_TRAVAUX_ERROR,
	payload: { error },
})

export const fetchClientsTravauxSuccess = (travaux) => ({
	type: FETCH_CLIENTS_TRAVAUX_SUCCESS,
	payload: { travaux },
})

export const fetchClientsTravauxReset = () => ({
	type: FETCH_CLIENTS_TRAVAUX_RESET,
})

export function fetchClientsTravaux(obj) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchClientsTravauxBegin())
		let url = `${URL}api/clientstravaux?`
		for (let [key, val] of Object.entries(obj)) url += `${key}=${val}&`
		return fetch(url.slice(0, -1), {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchClientsTravauxSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchClientsTravauxError))
	}
}

// DELETE CV FILE

export const DELETE_CV_BEGIN = "DELETE_CV_BEGIN"
export const DELETE_CV_SUCCESS = "DELETE_CV_SUCCESS"
export const DELETE_CV_ERROR = "DELETE_CV_ERROR"
export const DELETE_CV_RESET = "DELETE_CV_RESET"

export const deleteCVBegin = () => ({
	type: DELETE_CV_BEGIN,
})

export const deleteCVSuccess = (data) => ({
	type: DELETE_CV_SUCCESS,
	payload: { data },
})

export const deleteCVError = (error) => ({
	type: DELETE_CV_ERROR,
	payload: { error },
})

export const deleteCVReset = () => ({
	type: DELETE_CV_RESET,
})

export function deleteCV(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteCVBegin())
		return fetch(`${URL}api/clientstravaux`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(deleteCVSuccess(json)))
			.catch(catchApiError(dispatch, deleteCVError))
	}
}

// DELETE VEH FILE

export const DELETE_CV_FILE_BEGIN = "DELETE_CV_FILE_BEGIN"
export const DELETE_CV_FILE_SUCCESS = "DELETE_CV_FILE_SUCCESS"
export const DELETE_CV_FILE_ERROR = "DELETE_CV_FILE_ERROR"
export const DELETE_CV_FILE_RESET = "DELETE_CV_FILE_RESET"

export const deleteCVFileBegin = () => ({
	type: DELETE_CV_FILE_BEGIN,
})

export const deleteCVFileSuccess = (data) => ({
	type: DELETE_CV_FILE_SUCCESS,
	payload: { data },
})

export const deleteCVFileError = (error) => ({
	type: DELETE_CV_FILE_ERROR,
	payload: { error },
})

export const deleteCVFileReset = () => ({
	type: DELETE_CV_FILE_RESET,
})

export function deleteCVFile(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteCVFileBegin())
		return fetch(`${URL}api/cvfiles`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(deleteCVFileSuccess(json)))
			.catch(catchApiError(dispatch, deleteCVFileError))
	}
}
